export const insideImages = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/bYjZnbyZWXTCm9Qsi4tfDS/Captura_de_pantalla_2026-09-27_234145.png',
    alt: 'Page intérieure : fiche de cours Petit Allegro',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/p7oUDD7Z1WLsU2CBPg3APz/Captura_de_pantalla_2026-09-27_234122.png',
    alt: 'Page intérieure : circuit de correction des sauts',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/xugp85geVEC5AB1gxEVTVp/Captura_de_pantalla_2026-09-27_234036.png',
    alt: 'Page intérieure : fondations du saut',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/4SFKBU49hTC1Grpjr9sxnC/Captura_de_pantalla_2026-09-27_234015.png',
    alt: 'Page intérieure : 6 erreurs fréquentes de pirouette',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/hdfY3vxQWa5i1RZYhntHVK/Captura_de_pantalla_2026-09-27_233953.png',
    alt: 'Page intérieure : pirouette simple, séquence complète en 6 phases',
  },
]
